<template>
   <div class="tableHistorico">
      <table>
        <thead>
          <tr>
            
            <th>Codigo do Produto</th>
            <th>Produto</th>
            <th>Modelo</th>
            <th>Código Materia Prima</th>
            <th>Materia Prima</th>
            <td>Opção</td>

          </tr>
        </thead>
        <tbody v-for="l in lista" :key="l.id">
          <tr>
            
            <td>{{ l.cp }}</td>
            <td>{{ l.p }}</td>
            <td>{{ l.m}}</td>
            <td>{{ l.cmp }}</td>
            <td>{{ l.mp }}</td>
            <td>Excluir</td>
            
            </tr>
        </tbody>
      </table>
    </div>
</template>

<script>

export default {
  components: {  },
  name: "TableProdutoAndMateria",
  props : {
    lista : Array,
  }
};
</script>

<style>

.viewprocess {
  height: 15vh;
  width: 10vw;
  background-color: #fff;
  border: none;
  border-radius: 15px;
  color: var(--green);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.viewcont {
  display: flex;
  width: 100%;
}

.labelborder {
  background: var(--green);
  color: #fff;
  width: 2vw;
  min-width: 2vw;
  text-align: center;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  border-radius: 10px;
}

.table {
  width: 100%;
}
table{ font-family: "Poppins", sans-serif;}

tr {
  text-align: center;
}

.titleContent {
  margin-top: 30px;
  text-align: center;
  color: var(--gray);
}

.buttons {
  margin-top: 3rem;
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
}

.buttons .btnAnalise {
  width: 85%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

/* .buttons .solic {
  display: block;
  text-align: center;
  margin: 0 1rem 1rem 0;
  line-height: 2.5rem;
} */

.buttons .btnAnalise > div > h6 {
  color: var(--green);
  font-size: 1rem;
}

/* .tableHistorico {
  width: 100%;
  margin-top: 15px;
  background: var(--white);
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;
  border-radius: 10px;
} */

.tableHistorico {
  width: 100%;
  /* margin-top: 30px; */
  background: rgb(255, 255, 255);
  padding: 1rem;
  /* overflow-x: scroll; */
}

.tableHistorico table {
  width: 100%;
  border-collapse: collapse;
}

.tableHistorico table thead {
  border-top: none;
  border-bottom: none;
  background: #05c17a;
  color: #fff;
}

.tableHistorico table thead td {
  font-weight: 550;
  border-top: none;
  border-bottom: 1.5px solid var(--gray);
  background: #05c17a;
  color: #fff;
}

.tableHistorico table tbody td {
  border-bottom: 1px solid var(--gray);
}

.tableHistorico table tr td {
  text-align: center;
  padding: 15px;
}

.tableHistorico table tbody tr:hover {
  background: rgba(182, 182, 182, 0.438);
}
.tableHistorico table tbody .red {
  width: 30px;
  height: 100%;
  background: var(--red);
}
.tableHistorico table tbody .purple {
  width: 30px;
  height: 100%;
  background: var(--purple);
}
.tableHistorico table tbody .orange {
  width: 30px;
  height: 100%;
  background: var(--orange);
}
.tableHistorico table tbody .green {
  width: 30px;
  height: 100%;
  background: var(--green);
}
.tableHistorico table tbody .blue {
  width: 30px;
  height: 100%;
  background: var(--blue);
}
.tableHistorico .btnTable {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.tableHistorico .btnTable .btn:first-child {
  margin-bottom: 10px;
}
.tableHistorico .btnTable a {
  text-decoration: none;
}

@media (max-width: 1918px) {
  /* .tableHistorico {
    width: 100%;
    margin-top: 30px;
    background: rgb(255, 255, 255);
    padding: 1rem;
    overflow-x: scroll;
  } */

  /* .tableHistorico .btnTable a {
    margin-right: 10px;
  } */

  /* .buttons .btnAnalise .quad {
    display: inline-block;
    text-align: center;
    margin: 0 0.5rem 0.5rem 0;
    line-height: 1.9rem;
    padding: 15px;
    width: 11vw;
    font-size: 1rem;
  } */

  /* .buttons .btnAnalise > div > h6 {
    color: var(--green);
    font-size: 1rem;
  } */

  /* .buttons {
    display: inline-block;
    height: 15vh;
  } */

  /* .quad {
    display: flex;
  } */
}

@media (max-width: 1125px) {
  /* .tableHistorico {
    width: 100%;
    margin-top: 30px;
    background: rgb(255, 255, 255);
    padding: 1rem;
    overflow-x: scroll;
  } */

  /* .buttons .btnAnalise .quad {
    display: inline-block;
    text-align: center;
    margin: 0 0.5rem 0.5rem 0;
    line-height: 2rem;
    padding: 10px;
    width: 11vw;
  } */

  /* .buttons .btnAnalise > div > h6 {
    color: var(--green);
    font-size: 1rem;
  } */

  /* .tableHistorico .btnTable a {
    margin-right: 10px;
  } */
}

@media (max-width: 1024px) {
  /* .tableHistorico {
    width: 100%;
    margin-top: 30px;
    background: rgb(255, 255, 255);
    padding: 1rem;
    overflow-x: scroll;
  } */

  /* .buttons .btnAnalise .quad {
    display: inline-block;
    text-align: center;
    margin: 0 0.5rem 0.5rem 0;
    line-height: 2rem;
    padding: 10px;
    width: 11vw;
  } */

  /* .buttons .btnAnalise > div > h6 {
    color: var(--green);
    font-size: 1rem;
  } */

  /* .buttons {
    width: 100%;
  } */
}

@media (max-width: 800px) {
  .buttons .btnAnalise .quad {
    width: 45%;
  }
  /*
  .buttons .btnAnalise > div > h6 {
    color: var(--green);
    font-size: 1rem;
    width: 100%;
  } */

  /* label {
    font-size: 1.6rem;
  } */

  .buttons {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    gap: 1rem;
  }
  .viewprocess {
    width: 100%;
    padding: 60px 0;
  }

  .buttons .btnAnalise {
    width: 100%;
    gap: 1rem;
  }

  .labelborder {
    width: 20vw;
  }
}

/*renatinho
@media (max-width: 650px) {
  h2 {
    font-size: 1.2rem;
  }
  .titleContent {
    margin-top: 70px;
*/

@media (max-width: 425px) {
  .buttons .btnAnalise .quad {
    width: 100%;
  }
  /* 
  .buttons .btnAnalise .quad {
    display: inline-block;
    text-align: center;
    margin: 0 1rem 0.5rem 0;
    padding: 5px;
    width: 90%;
  }

  .buttons .btnAnalise > div > h6 {
    color: var(--green);
    font-size: 1.2rem;
  }*/
}
</style>
